export const SET_COLOR_SCHEME = 'SET_COLOR_SCHEME';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';
export const SET_SCROLL_POSITION_BY_ID = 'SET_SCROLL_POSITION_BY_ID';